import { combineReducers } from "redux";
import { chargebackSlice } from "./pages/chargeback/redux/slice";

export const financialServicesReducer = combineReducers({
  chargeback: chargebackSlice.reducer,

});
